export class SuggestionItem {
    public id: number;
    public name: string;
}